import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { environment } from '@env/environment';
import * as debug from 'debug';

const log = debug('edg:pusher');

@Injectable()
export class PusherService {
  private _pusherPrivate: any = null;
  private _pusherPublic: any = null;
  private _channels: any = {};

  isConnected(type: string = 'private'): boolean {
    if (type === 'private') {
      return this._pusherPrivate !== null;
    } else if (type === 'public') {
      return this._pusherPublic !== null;
    }
  }

  connect(accessToken?: string): void {
    this._channels = {};
    if (accessToken) {
      if (this._pusherPrivate) {
        try {
          // this.unsubscribeAll();
          // this._pusher.disconnect();
        } catch (e) {}
      }
      this._pusherPrivate = new Pusher(environment.pusher.clientId, {
        cluster: environment.pusher.cluster,
        encrypted: environment.pusher.encrypted,
        authEndpoint: environment.pusher.authEndpoint,
        auth: {
          headers: {
            Authorization: accessToken || '',
          },
        },
      });
    } else {
      this._pusherPublic = new Pusher(environment.pusher.clientId, {
        cluster: environment.pusher.cluster,
        encrypted: environment.pusher.encrypted,
        authEndpoint: environment.pusher.authEndpoint,
        auth: {
          headers: {
            Authorization: accessToken || '',
          },
        },
      });
    }
  }

  private(channel: string): any {
    return this.subscribe('private-' + channel);
  }

  subscribe(channel: string, type: string = 'private'): any {
    if (!this._channels[channel]) {
      this._channels[channel] =
        type === 'private' ? this._pusherPrivate.subscribe(channel) : this._pusherPublic.subscribe(channel);
    }
    return this._channels[channel];
  }

  unsubscribe(channel: string): void {
    try {
      this._pusherPrivate.unsubscribe(channel);
      if (this._channels[channel]) {
        delete this._channels[channel];
      }
    } catch (e) {
      log(e);
    }
  }

  unsubscribeAll(): void {
    for (const key in this._channels) {
      if (this._channels.hasOwnProperty(key)) {
        this.unsubscribe(key);
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/pusher.service.ts